import { AvailablePermissions } from './../app.const';
import { environment } from './../../environments/environment';
import { NotificationService } from './../common/services/notification/notification.service';
import { Router } from '@angular/router';
import {
  Component,
  OnInit,
  AfterViewInit,
  ComponentFactoryResolver,
  ViewContainerRef,
  OnDestroy,
  AfterViewChecked
} from '@angular/core';
import * as Cookies from 'js-cookie';
import store from './../store/store.module';
import {FETCH_LOGIN_DETAIL_REQUESTED, LOGOUT_REQUESTED} from './auth/login/login.actions';
import * as $ from 'jquery';
import MenuItem from '../models/MenuItem';
import * as _ from 'lodash';
import { PRINT_COMPLETED} from "../store/print/print.actions";
import {AppInjector} from "../app-injector";
import {ApiService} from "../api/api.service";
import {CREATE_GHOST_PRODUCTS_COMPLETED, LIST_GHOST_PRODUCTS_REQUESTED} from "./product/ghost/ghost.actions";
import {REINDEX_PRODUCT_COMPLETED} from "./product/list/list.actions";
import { SETUP_CURRENCY_REQUESTED } from '../store/action';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy, AfterViewInit {
  public store = store;
  public menuState = true;
  public unsubscribe;
  public reindexProductsPercentage = 0;
  public menus = _.map(
    [
      {
        label: 'Inventory',
        url: '/inventory',
        icon: 'fa fa-archive',
        active: false,
        parent_permissions: [AvailablePermissions.INVENTORY_VIEW],
        children: [
          {
            label: 'Products',
            url: '/inventory/products',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.INVENTORY_VIEW]
          },
          {
            label: 'Storage',
            url: '/inventory/storage',
            active: false,
            permissions: [AvailablePermissions.INVENTORY_VIEW]
          },
          {
            label: 'Bulk Update',
            url: '/inventory/batch',
            active: false,
            permissions: [AvailablePermissions.INVENTORY_VIEW]
          },
          {
            label: 'Scan Rack',
            url: '/inventory/scan-rack',
            permissions: [AvailablePermissions.INVENTORY_VIEW]
          },
          {
            label: 'Destination',
            url: '/destination',
            icon: 'fa fa-shopping-bag',
            active: false,
            permissions: [AvailablePermissions.INVENTORY_VIEW]
          },
          {
            label: 'Location',
            url: '/location',
            icon: 'fa fa-map-marker',
            active: false,
            permissions: [AvailablePermissions.INVENTORY_VIEW]
          },
          {
            label: 'Events',
            url: '/inventory/event',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.INVENTORY_VIEW]
          }
        ]
      },
      {
        label: 'Product',
        url: '/product',
        icon: 'fa fa-shopping-bag',
        active: false,
        parent_permissions: [AvailablePermissions.PRODUCT_VIEW],
        children: [
          {
            label: 'Product',
            url: '/product',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.PRODUCT_VIEW]
          },
          // {
          //   label: 'Ghost',
          //   url: '/ghost',
          //   icon: 'fa fa-snapchat-ghost',
          //   active: false,
          //   permissions: [AvailablePermissions.PRODUCT_CREATE_ALL]
          // },
          {
            label: 'Category',
            url: '/category',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.CATEGORY_VIEW]
          },
          {
            label: 'Size',
            url: '/size',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.SIZE_VIEW]
          },
          {
            label: 'Designer',
            url: '/designer',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.DESIGNER_VIEW]
          },
          {
            label: 'Style',
            url: '/style',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.STYLE_VIEW]
          },
          {
            label: 'Condition',
            url: '/condition',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.CONDITION_VIEW]
          },
          {
            label: 'Process Status',
            url: '/process-status',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.PROCESS_STATUS_VIEW]
          },
          {
            label: 'Process Status Group',
            url: '/process-status-group',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.PROCESS_STATUS_VIEW]
          },
          {
            label: 'Process Status Transition',
            url: '/process-transition',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.PROCESS_STATUS_VIEW]
          },
          {
            label: 'Process Type',
            url: '/process-type',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.PROCESS_TYPE_VIEW]
          },
          {
            label: 'Provider',
            url: '/provider',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.PROVIDER_VIEW]
          },
          {
            label: 'Currency',
            url: '/currency',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.CURRENCY_VIEW]
          },
          {
            label: 'Color',
            url: '/color',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.COLOR_VIEW]
          },
          {
            label: 'Wardrobe',
            url: '/wardrobe',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.WARDROBE_VIEW]
          },
          {
            label: 'Custom attribute',
            url: '/custom-attribute',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.CUSTOM_ATTRIBUTE_VIEW]
          }
        ]
      },
      {
        label: 'Collection',
        url: '/collection',
        icon: 'fa fa-address-book',
        active: false,
        parent_permissions: [AvailablePermissions.COLLECTION_VIEW],
        children: [
          {
            label: 'Collection',
            url: '/collection',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.COLLECTION_VIEW]
          }
        ]
      },
      {
        label: 'Customer',
        url: '/customer',
        icon: 'fa fa-users',
        active: false,
        parent_permissions: [AvailablePermissions.CUSTOMER_VIEW],
        children: [
          {
            label: 'Customer',
            url: '/customer',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.CUSTOMER_VIEW]
          }
        ]
      },
      {
        label: 'Order',
        url: '/order',
        icon: 'fa fa-shopping-bag',
        active: false,
        parent_permissions: [AvailablePermissions.ORDER_VIEW],
        children: [
          {
            label: 'Order',
            url: '/order',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.ORDER_VIEW]
          },
          {
            label: 'Shipment',
            url: '/shipment',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.ORDER_VIEW]
          },
          {
            label: 'Courier',
            url: '/courier',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.ORDER_COURIER_VIEW]
          }
        ]
      },
      {
        label: 'Coupon & Rule',
        url: '/cartrule',
        icon: 'fa fa-tags',
        active: false,
        parent_permissions: [AvailablePermissions.COUPON_VIEW_ALL],
        children: [
          {
            label: 'Rule',
            url: '/cartrule',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.COUPON_VIEW_ALL]
          },
          {
            label: 'Coupon',
            url: '/coupon',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.COUPON_VIEW_ALL]
          }
        ]
      },
      {
        label: 'Delivery',
        url: '/delivery/list',
        icon: 'fa fa-truck',
        active: false,
        parent_permissions: [AvailablePermissions.DELIVERY_VIEW],
        children: [
          {
            label: 'Delivery',
            url: '/delivery/list',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.DELIVERY_VIEW]
          },
          {
            label: 'Request',
            url: '/delivery/request',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.DELIVERY_CREATE]
          }
        ]
      },
      {
        label: 'Payment',
        url: '/payment/send',
        icon: 'fa fa-money',
        active: false,
        parent_permissions: [AvailablePermissions.PAYMENT_VIEW],
        children: [
          {
            label: 'Send',
            url: '/payment/send',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.PAYMENT_VIEW]
          },
          {
            label: 'Collect',
            url: '/payment/collect',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.PAYMENT_VIEW]
          }
        ]
      },
      {
        label: 'ACL',
        url: '/acl/roles',
        icon: 'fa fa-book',
        active: false,
        parent_permissions: [AvailablePermissions.ROLE_VIEW],
        children: [
          {
            label: 'Roles',
            url: '/acl/roles',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.ROLE_VIEW]
          }
        ]
      },
      {
        label: 'Users',
        url: '/user',
        icon: 'fa fa-user',
        active: false,
        parent_permissions: [AvailablePermissions.USER_VIEW],
        children: [
          {
            label: 'User',
            url: '/user',
            icon: '',
            active: false,
            permissions: [AvailablePermissions.USER_VIEW]
          }
        ]
      }
    ],
    item => new MenuItem(item)
  );

  constructor(private route: Router, private notification: NotificationService, private componentFactoryResolver: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef) {
    this.route = route;
    let subscribeProduct = store.subscribe(() => {
      let observedCode = (store as any).getState().Product.list.reindexProductsReceipt;
      if (observedCode) {
        AppInjector.get(ApiService).general.asyncStatus(observedCode, 3000, (val) => {
          this.reindexProductsPercentage = val.data.percentage;
        }).subscribe(s => {
          if (s !== 'Time out') {
            store.dispatch({ type: REINDEX_PRODUCT_COMPLETED });
            this.reindexProductsPercentage = 0;
          }
        });
      } else {
        this.reindexProductsPercentage = 0;
      }
    });
  }

  ngOnInit() {
    store.dispatch({ type: FETCH_LOGIN_DETAIL_REQUESTED });
    store.dispatch({ type: SETUP_CURRENCY_REQUESTED });
    this.unsubscribe = store.subscribe(() => {
      if ((store as any).getState().Print.status === true) {
        if ((store as any).getState().Print.component) {
          const factory = this.componentFactoryResolver.resolveComponentFactory((store as any).getState().Print.component);
          const ref = this.viewContainerRef.createComponent(factory);
          Object.keys((store as any).getState().Print.data).forEach(key => {
            ref.instance[key] = (store as any).getState().Print.data[key];
          });
          ref.changeDetectorRef.detectChanges();
          window.onafterprint = () => {
            ref.destroy();
            store.dispatch({ type: PRINT_COMPLETED });
          };
          window.print();
          if (window.matchMedia) {
            let mediaQueryList = window.matchMedia('print');
            mediaQueryList.addListener(function(mql) {
              if (!mql.matches) {
                ref.destroy();
                store.dispatch({ type: PRINT_COMPLETED });
              }
            });
          }
        }
      }
      if ((store as any).getState().Download.status === true) {
        if ((store as any).getState().Download.code) {

        }
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe();
  }

  ngAfterViewInit() {
    let $MENU_TOGGLE = $('#menu_toggle');
    $MENU_TOGGLE.click(() => {
      store.dispatch({ type: 'TOGGLE_SIDEBAR_MENU' });
    });
  }
  logout() {
    store.dispatch({ type: LOGOUT_REQUESTED });
    this.notification.show('success', 'You have logged out', 3000);
  }

  canNotAccess() {
    this.notification.show('warning', 'This page is not accessible right now', 3000);
  }

  toggleSidebar(evt) {
    //if only outside being clicked or when position is closed
    if (evt.target.className.indexOf('collapsable-sidebar') > -1 || this.menuState !== true) {
      this.menuState = !this.menuState;
      if (this.menuState === true) {
        $("body").attr('class', 'nav-md');
        $(".child_menu").removeClass('hidden');
      } else {
        $("body").attr('class', 'nav-sm');
        $(".child_menu").addClass('hidden');
      }
    }
  }
  navigateTo(path) {
    if (this.menuState === true) {
      $("body").attr('class', 'nav-md');
      $(".child_menu").removeClass('hidden');
      this.route.navigate([path]);
    }
  }
}
